<div class="google-place-autocomplete-host" #host>
  @if (lazyLoad && showFallbackInput) {
    <input
      #fallbackInput
      type="search"
      class="google-place-autocomplete-fallback"
      [id]="inputId"
      [name]="inputName"
      [attr.placeholder]="placeholder"
      [value]="fallbackValue"
      autocomplete="off"
      (input)="onFallbackInput($event)"
      (mousedown)="onFallbackPointerDown($event)"
      (focus)="onFallbackFocus()"
      (keydown)="onFallbackKeydown($event)"
      [attr.aria-label]="placeholder || 'Search location'" />
  }
</div>
